import { ANCHOR_TYPE, OFFSET_UNIT, TIMING_MODE } from '../constants'

const VISIT_LIKE_TYPES = [
  ANCHOR_TYPE.visit,
  ANCHOR_TYPE.arm,
  ANCHOR_TYPE.phase,
  ANCHOR_TYPE.visitCycle,
  ANCHOR_TYPE.track,
  ANCHOR_TYPE.chapter,
]

/**
 * Default deploy time_of_day (often 09:00) is only meaningful for day-anchored
 * schedules using "from start of day". Instrument chains and sub-day offsets
 * should not show a misleading clock time in summaries.
 */
export const shouldShowDeployTimeOfDay = schedule => {
  const anchor = schedule?.anchors?.[0]
  if (!anchor?.type) return false
  if (anchor.type === ANCHOR_TYPE.instrument) return false
  if (anchor.timingMode === TIMING_MODE.elapsedTime) return false

  const unit = String(anchor.offset?.unit || OFFSET_UNIT.days).toLowerCase()
  const amount = Number(anchor.offset?.amount ?? anchor.offset?.value ?? 0)
  if (amount && unit !== OFFSET_UNIT.days && unit !== 'days') return false

  if (anchor.type === ANCHOR_TYPE.fixedCalendarDate) return true
  if (VISIT_LIKE_TYPES.includes(anchor.type)) {
    return (anchor.timingMode || TIMING_MODE.fromStartOfDay) === TIMING_MODE.fromStartOfDay
  }
  return (anchor.timingMode || TIMING_MODE.fromStartOfDay) === TIMING_MODE.fromStartOfDay
}
